import './Categories.css';

import categories from '../categories-list';
function Categories({ setCurrentCategory }) {
	return (
		<ul className='aside'>
			<li className='category'>
				<button
					className='btn category-btn category-all'
					onClick={() => setCurrentCategory('all')}>
					All
				</button>
			</li>
			{categories.map((category) => (
				<li
					className='category'
					key={category.name}>
					<button
						className='btn category-btn'
						onClick={() => setCurrentCategory(category.name)}
						style={{ backgroundColor: category.color }}>
						{category.name}
					</button>
				</li>
			))}
		</ul>
	);
}
export default Categories;
